import React, { useEffect } from 'react'
import Founder from '../components/ui/Founder'
import {staff} from '../staff'

function Founders({isStaff}) {

  useEffect(() => {
    isStaff()
  },[])

  return (
    <main className='founders'>
        <div className="container">
            <div className="section-title">
                Our Team
            </div>
            <div className="founders-wrapper">
                {staff.map((elem) => <Founder member={elem} key={elem.id} />)}
            </div>
        </div>
    </main>
  )
}

export default Founders